import React from 'react'
import { ResizableBox } from 'react-resizable'
import PopupComponent from '../infoPopup/Popup.component'
import { IonList } from '@ionic/react'
import './ResizableDynamicPopover.component.css'

export interface IResizableDynamicPopoverProps {
  id: string
  dataTestId: string
  isOpen: boolean
  onClose: () => void
  event?: any
  headerContent?: React.ReactNode | string
  footerContent?: React.ReactNode
  content: React.ReactNode
  resizableBoxConstraints?: {
    width: number
    height: number
    minConstraints?: [number, number]
    maxConstraints?: [number, number]
  }
  popoverClasses?: string
}

const ResizableDynamicPopoverComponent: React.FC<IResizableDynamicPopoverProps> = ({
  id = 'ResizableDynamicPopover',
  isOpen,
  onClose,
  dataTestId,
  headerContent,
  footerContent,
  content,
  event,
  popoverClasses = '',
  resizableBoxConstraints = {
    width: 400,
    height: 350,
    minConstraints: [300, 300],
    maxConstraints: [550, 750],
  },
}) => {
  return (
    <PopupComponent
      id={id}
      dataTestId={dataTestId}
      isOpen={isOpen}
      handleHidePopover={onClose}
      event={event}
      className={`${popoverClasses} resizable-popover`}>
      <ResizableBox {...resizableBoxConstraints}>
        <>
          {headerContent}
          <IonList id='PopUpContent' data-testid='PopUpContent' className='popover-content'>
            {content}
          </IonList>
          {footerContent}
        </>
      </ResizableBox>
    </PopupComponent>
  )
}

export default ResizableDynamicPopoverComponent
